import { makeAuthenticatedApiCall } from '../services/authApi';
import { ZCLUB_API_URL } from '../config/api';

export const PAYGIFT_CLUB_CLAIM_BLOCKED = 'PAYGIFT_CLUB_CLAIM_BLOCKED';

export const PAYGIFT_CLUB_CLAIM_BLOCKED_MESSAGE =
  'Klaim anda gagal tolong hubungi CS Zoolyfe';

export function isPaygiftClubClaimBlockedError(error) {
  const code =
    error?.apiErrorCode ||
    error?.data?.error_code ||
    error?.error_code ||
    '';
  if (code === PAYGIFT_CLUB_CLAIM_BLOCKED) return true;
  const msg = String(error?.message || '').toLowerCase();
  return msg.includes('klaim anda gagal') && msg.includes('hubungi cs');
}

export function getPaygiftClubClaimBlockedUi(error) {
  const cs = error?.data?.cs_contact || error?.cs_contact || {};
  return {
    message:
      (typeof error?.message === 'string' && error.message.trim())
        ? error.message
        : PAYGIFT_CLUB_CLAIM_BLOCKED_MESSAGE,
    csContact: {
      email: String(cs.email || '').trim(),
      subject: String(cs.subject || '').trim(),
      body: String(cs.body || '').trim(),
      namaVoucher: String(cs.nama_voucher || '').trim(),
    },
  };
}

export async function reportPaygiftClubClaimBlock(csContact) {
  const result = await makeAuthenticatedApiCall(
    `${ZCLUB_API_URL}/report-paygift-club-claim-block`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        nama_voucher: String(csContact?.namaVoucher || '').trim(),
      }),
    }
  );

  if (result && result.status !== 'success' && result.ok === false) {
    throw new Error(result.message || 'Gagal mengirim laporan');
  }

  return result;
}
